/**
 * @file brandColors.js
 * @description Utilidades compartidas para colores de marcas de vehículos.
 * Usado en Sidebar y StatCard para asegurar colores consistentes.
 */

import { marcasColors } from '../data/patiosData';

/** Paleta de 12 colores profesionales para marcas sin color asignado */
export const FALLBACK_PALETTE = [
  '#1d2e61', // Continental navy (primary brand blue)
  '#0e4d92', // royal blue
  '#1a6985', // steel blue
  '#0f766e', // deep teal
  '#047857', // deep green
  '#92400e', // warm amber/bronze
  '#6d28d9', // deep violet
  '#9d174d', // deep crimson
  '#0369a1', // clear sky blue
  '#3730a3', // deep indigo
  '#0e7490', // deep cyan
  '#374151', // slate
];

/** Color determinístico basado en el nombre de marca — siempre retorna el mismo color */
export const derivedColor = (marca) => {
  const hash = marca.split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0);
  return FALLBACK_PALETTE[hash % FALLBACK_PALETTE.length];
};

/** Retorna el color explícito de la marca si existe, si no un color de la paleta */
export const getBrandColor = (marca) =>
  marca ? (marcasColors[marca] || derivedColor(marca)) : FALLBACK_PALETTE[0];
